// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_R7BpT","backToTop":"index_backToTop_g0QQl"};